<div class="header">
    <app-header
        [title]="'import.integrations.steps.software.title'"
        [subtitle]="'import.integrations.steps.software.description'"
    />
    <a href="{{ integrationsHelpLink }}" target="_blank"
        ><mat-icon svgIcon="help" />{{ 'import.integrations.help' | translate }}</a
    >
</div>
<div class="search-container">
    <mat-accordion>
        <mat-expansion-panel class="borderless">
            <mat-expansion-panel-header class="link" collapsedHeight="24px" expandedHeight="24px">
                <a>{{ 'import.integrations.steps.software.categoriesHelp' | translate }}</a>
            </mat-expansion-panel-header>
            <ul class="category-descriptions">
                <li *ngFor="let translation of categoryTranslations | keyvalue">
                    <strong>{{ translation.value.label.long ?? translation.value.label.default }}</strong> -
                    {{ translation.value.description }}
                </li>
            </ul>
        </mat-expansion-panel>
    </mat-accordion>
    <div class="filter">
        <app-filter [groups]="[categoryFilter]" (filter)="handleFilter()" />
    </div>
    <app-search (onSearch)="handleSearch($event)" />
</div>
<div class="card-grid" [class.loading]="isLoading">
    <app-integration-card
        *ngFor="let integration of filteredIntegrations"
        [id]="integration.name"
        [integrationType]="integration"
        [connectionState]="integration.status"
        [primaryAction]="PRIMARY_ACTIONS[integration.status]"
        [availableActions]="getAvailableActions(integration)"
        [styleOptions]="{ cardVariant: 'outline' }"
        (onAction)="onIntegrationAction($event, integration)"
    >
        <div class="description">
            <h4 class="no-margin">{{ 'import.integrations.providers.' + integration.name | translate }}</h4>
        </div>
    </app-integration-card>
    <app-empty-state
        *ngIf="!isLoading && !filteredIntegrations.length"
        label="{{ 'import.integrations.steps.software.notFound' | translate }}"
        src="/assets/illustrations/magnifying-glass.png"
    />
</div>
